export enum TodoCategoryCode {
    ProjectTodoTask = "project_todo_task"
}

export type TodoTaskCategory = {
    id: number
    code: TodoCategoryCode
    description: string
    count: number
}

export type TodoTaskCategoryList = TodoTaskCategory[]

export type TodoTaskCategoryAll = {
    total: number,
    todoCategoryList: TodoTaskCategoryList
}